import { Component, computed, ElementRef, HostListener, inject, Input, ViewChild } from "@angular/core";
import { Menu } from "./menu/menu";
import { UserInfo } from "./user-info/user-info";
import { MatIcon } from "@angular/material/icon";
import { UmbracoIndstillinger } from "@e-forsyning/common/umbraco-indstillinger";
import { Bruger } from "@e-forsyning/common/bruger";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { ThemeService } from "@dffedb/util";

@Component({
    selector: "top-navigation",
    imports: [Menu, UserInfo, MatIcon, RouterLink, RouterLinkActive],
    templateUrl: "./top-navigation.html",
    styleUrl: "./top-navigation.scss"
})
export class TopNavigation {
    @Input()
    public indstillinger: UmbracoIndstillinger;

    @Input()
    public aktuelBruger: Bruger;

    @Input()
    public menuItems: { label: string; icon: string; route: string; id?: string }[] = [];

    @ViewChild("burgerButton") private readonly burgerButton!: ElementRef<HTMLButtonElement>;

    public showMenu: boolean = false;
    public showInfo: boolean = false;
    public userInfoData: any;

    private readonly themeService = inject(ThemeService);
    public readonly isDark = computed(() => this.themeService.activeTheme() === "dark");

    constructor(private elementRef: ElementRef) {}

    @HostListener("document:click", ["$event"])
    public onDocumentClick(event: MouseEvent): void {
        if (this.showMenu && !this.elementRef.nativeElement.contains(event.target)) {
            this.showMenu = false;
        }
    }

    ngOnInit(): void {
        const initialer = (this.aktuelBruger?.initialer || "").trim();
        this.userInfoData = {
            user: {
                initialer,
                name: this.aktuelBruger ? this.aktuelBruger.navn : "",
                email: this.aktuelBruger ? this.aktuelBruger.email : ""
                //phone: this.aktuelBruger ? this.aktuelBruger.telefon : ""
            },
            works: {
                name: this.indstillinger ? this.indstillinger.firmaNavn : "",
                //address: this.indstillinger ? this.indstillinger.forsyningWeb.firmaInfo.  : "",
                phone:
                    this.indstillinger && this.indstillinger.forsyningWeb.firmaInfo && this.indstillinger.forsyningWeb.firmaInfo.telefon
                        ? this.indstillinger.forsyningWeb.firmaInfo.telefon
                        : ""
            }
        };
    }

    @HostListener("document:keydown.escape")
    public onEscape(): void {
        if (this.showMenu) {
            this.closeAndFocus();
        }
    }

    public toggleMenu(): void {
        this.showMenu = !this.showMenu;
        if (this.showMenu) {
            setTimeout(() => {
                const firstItem = document.querySelector<HTMLElement>('#user-dropdown-menu [role="menuitem"]');
                firstItem?.focus();
            });
        }
    }

    public closeAndFocus(): void {
        this.showMenu = false;
        setTimeout(() => this.burgerButton?.nativeElement?.focus());
    }

    public toggleTheme(): void {
        this.themeService.toggleTheme();
    }

    public openInfo(): void {
        this.showMenu = false;
        this.showInfo = true;
    }

    public closeInfo(): void {
        this.showInfo = false;
    }
}
